import { HighlightStyle, syntaxHighlighting } from '@codemirror/language';
import { tags as t } from '@lezer/highlight';

// Add classes for the various syntax highlighting tags, that we'll then style
// in our Sass stylesheets https://lezer.codemirror.net/docs/ref/#highlight.tags
const highlightClasses = [
  { tag: t.comment, class: 'cms-comment' },
  { tag: t.content, class: 'cms-content' },
  { tag: t.keyword, class: 'cms-keyword' },

  { tag: t.literal, class: 'cms-literal' },
  { tag: t.special(t.literal), class: 'cms-literal cms-special' },
  { tag: t.number, class: 'cms-literal cms-number' },
  { tag: t.bool, class: 'cms-literal cms-bool' },
  { tag: t.regexp, class: 'cms-literal cms-regexp' },

  { tag: t.name, class: 'cms-name' },
  { tag: t.attributeName, class: 'cms-name cms-attribute' },
  { tag: t.propertyName, class: 'cms-name cms-property' },
  { tag: t.variableName, class: 'cms-name cms-variable' },

  { tag: t.operator, class: 'cms-operator' },
  { tag: t.punctuation, class: 'cms-punctuation' },

  { tag: t.invalid, class: 'cms-invalid' },
];

export const themeHighlighting = HighlightStyle.define(highlightClasses);

export const theme = [syntaxHighlighting(themeHighlighting)];
